import { connect } from "react-redux";
import Registration from "./Registration.query";
import { mapStateToProps, mapDispatchToProps } from "./Registration.state";

export default connect(mapStateToProps, mapDispatchToProps)(Registration);
